import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Classes from "./Settings.module.css";
import Sidebar from "./Components/Sidebar/Sidebar";
import Profile from "./Components/Profile/Profile";
import { useSelector } from "react-redux";

export default function Settings() {
    const navigateTo = useNavigate();
    const [activeTab, setActiveTab] = useState("profile");
    const companyInfo = useSelector((state) => state.companyInfo?.info);
    const [colorScheme, setcolorScheme] = useState(companyInfo?.color);

    return (
        <div className={Classes.container}>
            <div className={Classes.header}>
                <div>
                    <h3>Settings</h3>
                    <h5>Manage your account settings and preferences.</h5>
                </div>
            </div>

            <div className={Classes.hero} >
                <div className={Classes.heroLeft}>
                    <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
                </div>
                <div className={Classes.heroRight} >
                    <div className="flexBetween mb-20" style={{ padding: '0 25px' }} >
                        <h3>{activeTab === 'profile' ? 'My Profile' : activeTab === 'team' ? 'Team' : ''}</h3>
                    </div>

                    {activeTab === "profile" && <Profile />}

                </div>
            </div>

        </div>
    );
}